import { Stack, Tag, Text } from '@chakra-ui/react'

import type { ProgressionLevel } from '@/queries/constants'

import MessageBox from '@/components/UI/MessageBox'
import UserAvatar from '@/components/UserAvatar'

export default function RegistrationModalTutorPrompt({
  tutorName,
  tutorAvatarUrl,
  tutorProgressionLevel,
}: {
  tutorName: string
  tutorAvatarUrl: string
  tutorProgressionLevel: ProgressionLevel
}): JSX.Element {
  return (
    <>
      <Stack alignItems={['flex-start', 'center']} direction={['column', 'row']} spacing={2} mb={4}>
        <UserAvatar
          src={tutorAvatarUrl ?? ''}
          name={tutorName}
          size="md"
          progressionLevel={tutorProgressionLevel}
        />
        <Text as="span" fontWeight="bold">
          {tutorName}
        </Text>
        <Tag backgroundColor="blue.subtle" color="blue.solid" fontWeight="bold" fontSize="small">
          Tutor
        </Tag>
      </Stack>
      <MessageBox
        text="To complete your registration, please answer a couple of questions!"
        mb={6}
      />
    </>
  )
}
